const logLevels = {
  error: 0,
  warn: 1,
  info: 2,
  debug: 3
};

export const logLevelError = logLevels[process.env.LOG_LEVEL] >= logLevels.error;

export const logLevelWarn = logLevels[process.env.LOG_LEVEL] >= logLevels.warn;

export const logLevelInfo = logLevels[process.env.LOG_LEVEL] >= logLevels.info;

export const logLevelDebug = logLevels[process.env.LOG_LEVEL] >= logLevels.debug;
